export enum RequestTrackerTypeEnum {
  Contribution = 'Contribution',
  Distribution = 'Distribution',
  /**
   * Matches `req.AccountRequestType` for type 2, and the Category literal every arm of
   * figdata-acm's Requests query emits. Was 'Re-Allocation'; the hyphen was dropped so
   * one spelling covers the v1 and V2 workflows, which are one request type to an advisor.
   */
  Reallocation = 'Reallocation',
  CloseAccount = 'Close Account',
  //PlanningDesk = 'Planning Desk',
  PortfolioAnalyisDesk = 'Portfolio',
  OrionServiceRequest = 'Orion Service Request',
  GeneralAccount = 'General Account',
  /**
   * ⚠️ REMOVED (ACMTECH-997): `InitialAccount = 'Initial Account'` was here.
   *
   * The request type is being sunset, so figdata-acm's `[req]` arm emits `Reallocation` for type 1
   * and nothing produces this literal any more. A member nothing emits is a filter option that can
   * only ever return nothing.
   *
   * 🟢 The type has NOT gone away — an initial account still exists, still files and still opens.
   * The detail modal keeps its `case 1:` and titles it correctly; only the *category* is merged.
   */
  Clients = 'Clients',
  Sleeves = 'Allocations',
  Trades = 'Trades',
  Accounts = 'Accounts',
  /**
   * Custodial cash the advisor freed on step 1 to fund the request.
   *
   * ⚠️ NOT "Positions Being Sold". Nothing is traded for these -- they file under their own
   * req.TradeAction (4, Cash) precisely so they are not sells, and calling them a sale here would
   * put the advisor's tracker back at odds with both CRM and the wizard.
   */
  CashUsed = 'Cash Used',
  PositionsSold = 'Positions Being Sold',
  PositionsBought = 'Positions Being Bought',
  /**
   * The allocation as it stood when the wizard loaded, from the request's type-1 `req.Allocation`
   * row. Absent on an Initial Account (no before-state exists) and on anything filed before
   * ACMTECH-908 — in both cases the section is not rendered at all, because an empty before-state
   * means "not recorded" rather than "the account had no sleeves".
   */
  CurrentAllocation = 'Current Allocation',
  CustomHoldings = 'Custom Holdings',
}
export interface MessageAndFileModel {
  CreatedByUser: string | null;
  CreatedByUserName: string | null;
  CreatedOn: Date | null;
  ExternalStatus: string | null;
  Note: string | null;
  FileName : string | null;
  FileID : string | null;
  StatusID: number | null;
}